const menuPhotoExport = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
        <g stroke="#F5F5F5" stroke-linejoin="round">
          <g transform="translate(8.25 8.25)">
            <polyline stroke-linecap="round" points="4.313 3.938 6.188 5.813 8.063 3.938" transform="rotate(-90 6.188 4.875)"/>
            <circle cx="4.875" cy="4.875" r="4.5" transform="rotate(-90 4.875 4.875)"/>
            <path stroke-linecap="round" d="M4.875,2.625 L4.875,7.125" transform="rotate(-90 4.875 4.875)"/>
          </g>
          <g stroke-linecap="round">
            <path d="M14.625 3.393C14.625 5.0475 11.4345 6.393 7.5 6.393 3.5655 6.393.375 5.0475.375 3.393.375 1.7355 3.5655.375 7.5.375 11.4345.375 14.625 1.7355 14.625 3.393zM7.5 9.393C3.5655 9.393.375 8.0475.375 6.393M6.375 12.7305C2.97525 12.5025.375 11.262.375 9.76875"/>
            <path d="M6.75 16.11825C3.168 15.96.375 14.69325.375 13.143L.375 3.375M14.625 3.375L14.625 6.75"/>
          </g>
        </g>
        <rect width="18" height="18"/>
      </g>
    </svg>

`;

export default menuPhotoExport;
